export default {
  name: 'Charts',
  displayName: {
    en: 'Charts',
    ja: 'チャート',
  },
  defaultWidth: 375,
  defaultHeight: 328,
  resizeX: true,
  resizeY: true,
  props: [
    // === DATA SOURCE CONFIGURATION ===
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
      enableFieldSelection: true,
      enableFieldStyle: true,
    },

    // === BASIC CHART CONFIGURATION ===
    {
      name: 'chartType',
      displayName: {
        en: 'Chart Type',
        ja: 'Chart Type',
      },
      type: 'text',
      default: 'solid',
      control: {
        type: 'menu',
        options: [
          {
            label: 'Radar Chart',
            value: 'radar',
          },
          {
            label: 'Bar Chart',
            value: 'bar',
          },
          {
            label: 'Line Chart',
            value: 'line',
          },
        ],
      },
    },

    // === COLOR CONFIGURATION ===
    {
      name: 'chartColor',
      displayName: {
        en: 'Chart Color',
        ja: 'Chart Color',
      },
      type: 'color',
      default: '@primaryColor',
    },
    {
      name: 'fieldColorNote',
      displayName: {
        en: 'Field Colors',
        ja: 'フィールドの色',
      },
      type: 'note',
      content: {
        en: 'Individual field colors can be configured in the Field Style section when selecting fields above. Each selected field will have its own color picker.',
        ja: '上でフィールドを選択する際に、フィールドスタイルセクションで個別のフィールドの色を設定できます。選択された各フィールドには独自のカラーピッカーがあります。',
      },
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'defaultFieldColor',
      displayName: {
        en: 'Default Field Color',
        ja: 'デフォルトフィールドカラー',
      },
      type: 'color',
      default: '#0175ff',
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'autoAssignColors',
      displayName: {
        en: 'Auto-assign Colors to New Fields',
        ja: '新しいフィールドに自動で色を割り当て',
      },
      type: 'switch',
      default: true,
      enabled: {
        chartType: 'line',
      },
    },

    {
      name: 'maxValue',
      displayName: {
        en: 'Max Value for Number Fields',
        ja: '数値フィールドの最大値',
      },
      type: 'text',
      default: '200',
      enabled: {
        chartType: 'line',
      },
    },
    // === AXIS CONFIGURATION ===
    // X-Axis Configuration
    {
      name: 'xAxisField',
      displayName: {
        en: 'X-Axis Field',
        ja: 'X軸フィールド',
      },
      type: 'text',
      role: 'listItem',
      reference: 'items',
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'showXAxisLabel',
      displayName: {
        en: 'Show X-Axis Label',
        ja: 'X軸ラベルを表示',
      },
      type: 'switch',
      default: true,
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'xAxisLabel',
      displayName: {
        en: 'X-Axis Label',
        ja: 'X軸ラベル',
      },
      type: 'text',
      default: 'X',
      enabled: {
        chartType: 'line',
        showXAxisLabel: true,
      },
    },

    // Y-Axis Configuration
    {
      name: 'yAxisField',
      displayName: {
        en: 'Y-Axis Field',
        ja: 'Y軸フィールド',
      },
      type: 'text',
      role: 'listItem',
      reference: 'items',
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'showYAxisLabel',
      displayName: {
        en: 'Show Y-Axis Label',
        ja: 'Y軸ラベルを表示',
      },
      type: 'switch',
      default: true,
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'yAxisLabel',
      displayName: {
        en: 'Y-Axis Label',
        ja: 'Y軸ラベル',
      },
      type: 'text',
      default: 'Y',
      enabled: {
        chartType: 'line',
        showYAxisLabel: true,
      },
    },

    // === LEGEND CONFIGURATION ===
    {
      name: 'showLegend',
      displayName: {
        en: 'Show Legend',
        ja: '凡例を表示',
      },
      type: 'switch',
      default: true,
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'legendPosition',
      displayName: {
        en: 'Legend Position',
        ja: '凡例の位置',
      },
      type: 'text',
      default: 'top',
      enabled: {
        chartType: 'line',
        showLegend: true,
      },
      control: {
        type: 'menu',
        options: [
          {
            label: 'Top',
            value: 'top',
          },
          {
            label: 'Bottom',
            value: 'bottom',
          },
        ],
      },
    },

    {
      name: 'showHorizontalGrid',
      displayName: {
        en: 'Show Horizontal Grid Lines',
        ja: '水平グリッド線を表示',
      },
      type: 'switch',
      default: true,
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'showVerticalGrid',
      displayName: {
        en: 'Show Vertical Grid Lines',
        ja: '垂直グリッド線を表示',
      },
      type: 'switch',
      default: true,
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'gridLineColor',
      displayName: {
        en: 'Grid Line Color',
        ja: 'グリッド線の色',
      },
      type: 'color',
      default: '#e3e3e3',
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'gridLineWidth',
      displayName: {
        en: 'Grid Line Width',
        ja: 'グリッド線の幅',
      },
      type: 'number',
      default: 1,
      enabled: {
        chartType: 'line',
      },
      control: {
        min: 0.5,
        max: 3,
        step: 0.5,
      },
    },
    {
      name: 'gridLineStyle',
      displayName: {
        en: 'Grid Line Style',
        ja: 'グリッド線のスタイル',
      },
      type: 'text',
      default: 'solid',
      enabled: {
        chartType: 'line',
      },
      control: {
        type: 'menu',
        options: [
          {
            label: 'Solid',
            value: 'solid',
          },
          {
            label: 'Dashed',
            value: 'dashed',
          },
          {
            label: 'Dotted',
            value: 'dotted',
          },
        ],
      },
    },

    // === DATE FILTER CONFIGURATION ===
    {
      name: 'showDateFilter',
      displayName: {
        en: 'Show Date Filter',
        ja: '日付フィルターを表示',
      },
      type: 'switch',
      default: false,
      enabled: {
        chartType: 'line',
      },
    },
    {
      name: 'filterButtonActiveColor',
      displayName: {
        en: 'Filter Button Active Color',
        ja: 'フィルターボタンのアクティブカラー',
      },
      type: 'color',
      default: '#007AFF',
      enabled: {
        chartType: 'line',
        showDateFilter: true,
      },
    },
    {
      name: 'filterButtonInactiveColor',
      displayName: {
        en: 'Filter Button Inactive Color',
        ja: 'フィルターボタンの非アクティブカラー',
      },
      type: 'color',
      default: '#f0f0f0',
      enabled: {
        chartType: 'line',
        showDateFilter: true,
      },
    },
    {
      name: 'filterButtonTextActiveColor',
      displayName: {
        en: 'Filter Button Active Text Color',
        ja: 'フィルターボタンのアクティブテキストカラー',
      },
      type: 'color',
      default: '#ffffff',
      enabled: {
        chartType: 'line',
        showDateFilter: true,
      },
    },
    {
      name: 'filterButtonTextInactiveColor',
      displayName: {
        en: 'Filter Button Inactive Text Color',
        ja: 'フィルターボタンの非アクティブテキストカラー',
      },
      type: 'color',
      default: '#666666',
      enabled: {
        chartType: 'line',
        showDateFilter: true,
      },
    },
  ],
};
